export const P3_BASE_CSS_VARS = {
  "theme-website-p3-color-text": "var(--theme-website-color-text-muted)",
  "theme-website-p3-font-family": "InterVariable",
  "theme-website-p3-font-size": "1rem",
  "theme-website-p3-font-weight": "400",
  "theme-website-p3-line-height": "1.6",
  "theme-website-p3-letter-spacing": "0",
};
